import * as React from 'react'

import { Box, SearchField, Skeleton } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import EmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import type { FilterOption as MultiFilterOption } from 'modules/core/components/MultiFilters/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

import filterFields from 'modules/attendance/components/TimeTracking/Content/_Table/_filters/filterFields'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'

type SearchFieldProps = React.ComponentProps<typeof SearchField>

interface Props {
  filtersForm: FiltersForm
  onSearch: SearchFieldProps['onSearch']
  search: string
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: () => void
  onCancel: () => void
  canSendEmailReminder: boolean
}

const SearchBar = ({
  onSearch,
  search,
  filters,
  logicOperator,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
  canSendEmailReminder,
}: Props) => {
  const { featureAvailability: showRealTimeAttendance } = useAttendanceFeatures(
    Features.time_tracking_real_time_attendance
  )

  const { featureAvailability: hasTimeTrackingInconsistencies } = useAttendanceFeatures(
    Features.time_tracking_time_alerts
  )
  const [fields, setFields] = React.useState<readonly MultiFilterOption[]>([])

  const { loading } = useAsyncData(async () => {
    const fields = await filterFields(
      showRealTimeAttendance,
      canSendEmailReminder,
      hasTimeTrackingInconsistencies
    )

    setFields(fields)
  }, [])

  return (
    <>
      <Box flexNoShrink>
        {loading && <Skeleton width="s96" height="s32" />}
        {!loading && (
          <EmployeeMultiFilters
            label={i18n.t('filters.multi_filters.title')}
            fields={fields}
            filters={filters}
            logicOperator={logicOperator}
            onAddFilter={onAddFilter}
            onRemoveFilter={onRemoveFilter}
            onApplyFilters={onApplyFilters}
            onCancel={onCancel}
          />
        )}
      </Box>
      <Box width="full">
        <SearchField
          variant="big"
          onSearch={onSearch}
          search={search}
          placeholder={i18n.t('common.search')}
        />
      </Box>
    </>
  )
}

export default observer(SearchBar)
